import { Compass, TriangleAlert } from "lucide-react";
import { isRouteErrorResponse, Link, useRouteError } from "react-router";

import { useT } from "@/shared/i18n/useT";
import { Button } from "@/shared/ui/Button";
import { EmptyState } from "@/shared/ui/EmptyState";
import { buttonVariants } from "@/shared/ui/styles";

const HTTP_NOT_FOUND = 404;

/** A page that does not exist in the portal: back to the client's home. */
export function PortalNotFound() {
  const t = useT();
  return (
    <EmptyState
      icon={Compass}
      title={t("portal.notFound.title")}
      body={t("portal.notFound.body")}
      action={
        <Link to="/portal" className={buttonVariants()}>
          {t("portal.notFound.home")}
        </Link>
      }
    />
  );
}

/** When a portal page fails to load or render: a reload and a way home, never a blank page. */
export function PortalRouteError() {
  const t = useT();
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === HTTP_NOT_FOUND) return <PortalNotFound />;
  return (
    <div className="mx-auto flex min-h-dvh w-full max-w-2xl flex-col justify-center bg-canvas px-4">
      <EmptyState
        icon={TriangleAlert}
        tone="danger"
        title={t("errors.unexpected.title")}
        body={t("errors.unexpected.body")}
        action={
          <div className="flex flex-wrap justify-center gap-2">
            <Button
              onClick={() => {
                window.location.reload();
              }}
            >
              {t("common.retry")}
            </Button>
            <Link to="/portal" className={buttonVariants({ variant: "secondary" })}>
              {t("portal.notFound.home")}
            </Link>
          </div>
        }
      />
    </div>
  );
}
